import FlowResponsesPage from '../pages/dashboard/components/pages/FlowResponsesPage';

export default function FlowResponsesRoute() {
  return <FlowResponsesPage />;
}
